module.exports = __webpack_public_path__ + "static/media/no-store.b2ab8292.svg";